import React from 'react'
import { Table } from 'react-bootstrap'
import { formatTimeString } from '../../utils/formatters'

const TransactionNotesTable = ({ data }) => (
  <div className='ibox float-e-margins animated fadeIn section-shadow'>
    <Table striped bordered hover>
      <thead>
        <tr className='tbl-font-bold'>
          <th>Id</th>
          <th>Note</th>
          <th>Active</th>
          <th>Created By</th>
          <th>Created</th>
          <th>Updated</th>
        </tr>
      </thead>
      <tbody>
        {data.map((d, i) => (
          <tr key={i}>
            <td>{d.id}</td>
            <td>{d.note}</td>
            <td>{d.is_active ? 'Yes' : 'No'}</td>
            <td>{d.created_by}</td>
            <td>{formatTimeString(d.created)}</td>
            <td>{formatTimeString(d.updated)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
)

export default TransactionNotesTable
